import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { mediaQuery, Spacings } from '@styles/index';
import boxShadowGenerator from '@utils/boxShadowGenerator';
import EnrolledBatchState from '@cont/BatchGroup/Footer/EnrolledBatchState';
import UnEnrolledBatchState from '@cont/BatchGroup/Footer/UnEnrolledBatchState';

const Wrapper = styled.div`
  opacity: 0;
  z-index: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: fixed;
  width: ${Spacings.APP_CONTAINER_WIDTH};
  transition: all 300ms ease;
  justify-content: space-between;
  background-color: var(--color-base-0);
  &.scrolled {
    opacity: 1;
    z-index: 10;
    ${mediaQuery.aboveMobile} {
      top: ${Spacings.SPACING_18B};
    }
    ${mediaQuery.uptoMobile} {
      border-top: 1px solid var(--color-divider);
      display: flex;
      width: 100%;
      bottom: ${Spacings.SPACING_0B};
      left: ${Spacings.SPACING_0B};
      padding: ${Spacings.SPACING_4B};
      top: initial;
      margin-bottom: ${Spacings.SPACING_0B};
      box-shadow: ${boxShadowGenerator()};
      border-radius: ${Spacings.SPACING_0B};
    }
  }
  ${mediaQuery.uptoMobile} {
    display: none;
  }
`;

const BatchState = ({
  scroll,
  batchUID,
  onJoinBatch,
  slashPriceMessage,
  batch
}) => {
  const { isEnrolled } = batch;
  return (
    <Wrapper scroll={scroll} className={scroll ? 'scrolled' : ''}>
      {isEnrolled ? (
        <EnrolledBatchState batchDetails={batch} />
      ) : (
        <UnEnrolledBatchState
          onJoinBatch={onJoinBatch}
          slashPriceMessage={slashPriceMessage}
          batchDetails={batch}
          batchUID={batchUID}
        />
      )}
    </Wrapper>
  );
};

export default BatchState;
BatchState.defaultProps = {
  onJoinBatch: () => null,
  slashPriceMessage: PropTypes.string
};
BatchState.propTypes = {
  batchUID: PropTypes.objectOf(PropTypes.any).isRequired,
  scroll: PropTypes.bool.isRequired,
  onJoinBatch: PropTypes.func,
  slashPriceMessage: ''
};
